export enum OperationKey {
    AcceptEnforcement = "ACCEPT_ENFORCEMENT",
    DeclineEnforcement = "DECLINE_ENFORCEMENT",
    SetDefaults = "SET_DEFAULTS"
}
